<!--
/**
  * 表单详情导航条组件
  * @author weili
  * @date 2023-05-24
  使用说明：
    navlist  导航名称集合
    modelClass  区域块的类名
  */
-->
<template>
    <!--滚动内容-->
    <div class="content" @scroll="handleScroll">
      <slot></slot>
      <!--导航条-->
      <div class="navlist">
          <div
              v-for="(item, index) in navlist"
              :key="index"
              class="nav-item"
              :class="['nav-item',activeStep == index ?'currentTab':'tab']"
              @click="jump(index)"
              >
              {{ item.name }}
          </div>
      </div>
    </div>
</template>
<script>
export default {
  name: 'EXNavList',
  props: {
    navlist: {
      type: Array,
      default: () => ([])
    },
    modelClass: {
        type: String,
        default: "ex-model"
    }
  },
  data(){
    return {
        activeStep: 0,
    }
  },
  computed:{
   
  },
  methods: {
        handleScroll(e) {
            const scrollItems = document.querySelectorAll(`.${this.modelClass}`);
            for (let i = scrollItems.length - 1; i >= 0; i--) {
                let judge =
                e.target.scrollTop >=
                scrollItems[i].offsetTop - scrollItems[0].offsetTop;
                if (judge) {
                this.activeStep = i;
                break;
                }
            }
            let el = document.querySelector(".content");
            let isBottom = el.scrollTop + el.clientHeight - el.scrollHeight;
            if (isBottom >= 0) {
                this.activeStep = scrollItems.length - 1;
            }
        },
        // 点击切换锚点
        jump(index) {
            let target = document.querySelector(".content");
            let scrollItems = document.querySelectorAll(`.${this.modelClass}`);
            // 判断滚动条是否滚动到底部
            // if (target.scrollHeight <= target.scrollTop + target.clientHeight) {
                this.activeStep = index;
            // }
            let total = scrollItems[index].offsetTop - scrollItems[0].offsetTop; // 锚点元素距离其offsetParent(这里是body)顶部的距离(待滚动的距离)
            let distance = document.querySelector(".content").scrollTop; // 滚动条距离滚动区域顶部的距离
            // let distance = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset // 滚动条距离滚动区域顶部的距离(滚动区域为窗口)
            // 滚动动画实现, 使用setTimeout的递归实现平滑滚动，将距离细分为50小段，10ms滚动一次
            // 计算每一小段的距离
            let step = total / 50;
            if (total > distance) {
                smoothDown(document.querySelector(".content"));
            } else {
                let newTotal = distance - total;
                step = newTotal / 50;
                smoothUp(document.querySelector(".content"));
            }

            // 参数element为滚动区域
            function smoothDown(element) {
                if (distance < total) {
                distance += step;
                element.scrollTop = distance;
                setTimeout(smoothDown.bind(this, element), 10);
                } else {
                element.scrollTop = total;
                }
            }

            // 参数element为滚动区域
            function smoothUp(element) {
                if (distance > total) {
                distance -= step;
                element.scrollTop = distance;
                setTimeout(smoothUp.bind(this, element), 10);
                } else {
                element.scrollTop = total;
                }
            }
        },
  },
};
</script>
<style lang="scss" scoped>
@import '../../styles/variables.scss';
.content {
  overflow-x: hidden;
  overflow-y: scroll;
  height: 100%;
}
.navlist {
  position: absolute;
  top: 2.4rem;
  right: 0.16rem;
  text-align: center;
  width: 2rem;
  .nav-item {
    line-height: 0.5rem;
    &:hover {
      cursor: pointer;
    }
  }
}
.currentTab{
  @include table_font_color($table-btn-colorD);
 }
 .tab{
  color: #333;
}
</style>


// WEBPACK FOOTER //
// src/components/EXDetail/EXNavList.vue